import React, {useContext, useEffect, useRef} from 'react';
import { MyContext } from '../context/my_context';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/header_aux.css';
import logoAlcaldiaSivep from "../assets/images/logos/Logos_Alcaldia_SIVEP.jpg";
import homeIcon from "../assets/images/icons/home-icon.jpeg";

const Header: React.FC = () => {
    const context = useContext(MyContext);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [menuOpen, setMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const handleClickOutside = (event: any) => {
        if (
            dropdownRef.current && !dropdownRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)
        ) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (context === undefined) {
        throw new Error('Header must be used within a MyProvider');
    }

    const navigate = useNavigate();
    const { isAuthenticated, setIsAuthenticated } = context;

    const handleClick00 = () => {
        setMenuOpen(false);
        navigate('/home');
    };

    const handleClick01 = () => {
        setMenuOpen(false);
        navigate('/user_profile');
    };

    const handleClick04 = () => {
        setMenuOpen(false);
        navigate('/help_support');
    };

    const handleClick05 = () => {
        setMenuOpen(false);
        navigate('/seller_profile');
    };

    const handleClick06 = () => {
        setMenuOpen(false);
        navigate('/qr_reader_view');
    };

    const handleClick07 = () => {
        setMenuOpen(false);
        navigate('/search_seller_by_document');
    };

    const handleLogout = () => {
        // Remove authentication data from local storage
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTimestamp');

        // Update the authentication status
        setIsAuthenticated(false);

        // Redirects to the login page
        navigate('/');
    };

    if (!isAuthenticated) {
        // Do not render the Header if the user is not authenticated
        // If the user is not logged in, they should not see that Header with options that are not relevant
        return null;
    }

    return (
        <header className="header-aux">
            <div className="header-aux-buttons">
                <div className="dropdown" ref={dropdownRef}>
                    <ul className={`nav-list-aux ${menuOpen ? 'open' : ''}`}>
                        <li><button onClick={handleClick00}>Menú principal</button></li>
                        <li><button onClick={handleClick06}>Leer código QR del Modulo</button></li>
                        <li><button onClick={handleClick07}>Buscar Ventero por documento</button></li>
                        <li><button onClick={handleClick05}>Perfil del Ventero</button></li>
                        <li><button onClick={handleClick01}>Perfil del Usuario</button></li>
                        <li><button onClick={handleClick04}>Soporte</button></li>
                        <li><button onClick={handleLogout}>Logout</button></li>
                    </ul>
                </div>
            </div>
            <div className="header-aux-container">
                <img src={logoAlcaldiaSivep} alt="Logo" className="header-aux-logo"/>
            </div>
            <button ref={buttonRef} className="menu-aux-icon" onClick={toggleMenu} aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}>
                {menuOpen ? (
                    <i className="fas fa-times icon-header"></i>
                ) : (
                    <img src={homeIcon} alt="Lock icon" className="fas fa-home icon-header-home"/>
                )}
            </button>
        </header>
    );
};

export default Header;